import { useState } from 'react';

export default function useToggle(initialState = false) {
  const [toggled, setToggled] = useState(initialState);
  const toggle = () => setToggled(!toggled);
  return [toggled, toggle];
}
